import React, { useState } from 'react';
import axios from 'axios';
import GlobalStyle from './GlobalStyle';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post('/api/login',
      { username, password },
      { withCredentials: true }
      );
      localStorage.setItem('token', res.data.token);
      onLogin(); // questo riporta l'app nello stato autenticato
    } catch (err) {
      alert('Login fallito');
    }
  };

  return (
    <>
    <GlobalStyle />
    <div style={{
      height: '100vh',
      background: 'url("login.jpg") center/cover no-repeat',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <form onSubmit={handleSubmit} style={{
        background: 'white',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 0 10px rgba(0,0,0,0.3)'
      }}>
        <h2>Login</h2>
        <input value={username} onChange={e => setUsername(e.target.value)} placeholder="Username" />
        <br />
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" />
        <br />
        <button type="submit">Login</button>
      </form>
    </div>
    </>
  );
}

export default Login;
